export default "__VITE_ASSET__Cv6qvoN1__"